import { NgModule } from "@angular/core";

import { FilterPipe } from "src/app/pipes/filter.pipe";
import { UIdPipe } from "src/app/pipes/uid.pipe";
import { StatusIconPipe } from "src/app/pipes/status-icon.pipe";
import { StatusClassPipe } from "src/app/pipes/status-class.pipe";
import { BitratePipe } from "src/app/pipes/bitrate.pipe";
import { DesnakePipe } from "src/app/pipes/desnake.pipe";
import { FeederInputPipe } from "src/app/pipes/feeder-input.pipe";
import { FeederInputStatusPipe } from "src/app/pipes/feeder-input-status.pipe";
import { UptimePipe } from "src/app/pipes/uptime.pipe";
import { DateTimeZonePipe } from "src/app/pipes/date-time-zone.pipe";
import { TimezonePipe } from "src/app/pipes/timezone.pipe";
import { SingularPipe } from "src/app/pipes/singular.pipe";
import { MinuteSecondsPipe } from "src/app/pipes/minutes-seconds.pipe";
import { MultiLevelFilter } from "src/app/pipes/multilevelFilter.pipe";
import { BracketsPipe, NamesPipe } from "src/app/pipes/names.pipe";
import { MapPipe } from "src/app/pipes/map.pipe";
import { TimestampPipe } from "src/app/pipes/timestamp.pipe";
import { ErrorMessagePipe } from "src/app/pipes/error-message.pipe";
import { ObjectTypeLetterPipe } from "src/app/pipes/object-type-letter.pipe";
import { FirstLetterPipe } from "src/app/pipes/first-letter.pipe";
import { OrderByLocalPipe, OrderByPipe } from "src/app/pipes/order-by.pipe";
import { StatusTextPipe } from "src/app/pipes/status-text.pipe";
import { StatePipe } from "src/app/pipes/state.pipe";
import { VersionPipe } from "src/app/pipes/version.pipe";
import { BroadcasterInputPartialPipe, BroadcasterInputPipe } from "src/app/pipes/broadcaster-input.pipe";
import { TargetStatusTextPipe } from "src/app/pipes/target-status-text.pipe";
import { SafeUrlPipe } from "src/app/pipes/safe-url.pipe";
import { BytesPipe } from "src/app/pipes/bytes.pipe";
import { FeederInputTypePipe } from "src/app/pipes/feeder-input-type.pipe";
import { FeederInputSourcePipe } from "src/app/pipes/feeder-input-source.pipe";
import { ZecInputPipe } from "src/app/pipes/zec-input.pipe";
import { ZecInputStatusPipe } from "src/app/pipes/zec-input-status.pipe";
import { NetworkPipe } from "src/app/pipes/network.pipe";
import { ChromaMapperPipe } from "src/app/pipes/chroma-mapper.pipe";
import { LocationDisplayNamePipe } from "src/app/pipes/location-display-name.pipe";
import { DeescalatePipe } from "src/app/pipes/deescalate.pipe";
import { BroadcasterInputStatusPipe } from "src/app/pipes/broadcaster-input-status.pipe";
import { ReceiverOutputTargetPipe } from "src/app/pipes/receiver-output-target.pipe";
import { ReceiverOutputStatusPipe } from "src/app/pipes/receiver-output-status.pipe";
import { ReceiverOutputTypePipe } from "src/app/pipes/receiver-output-type.pipe";
import { ReceiverOutputPipe } from "src/app/pipes/receiver-output.pipe";
import { BroadcasterOutputStatusPipe } from "src/app/pipes/broadcaster-output-status.pipe";
import { BroadcasterOutputErrorPipe } from "src/app/pipes/broadcaster-output-error.pipe";
import { BroadcasterOutputPipe } from "src/app/pipes/broadcaster-output.pipe";

@NgModule({
    imports: [
        //
        FirstLetterPipe,
        StatusClassPipe,
        StatusTextPipe,
        TargetStatusTextPipe,
        StatusIconPipe,
        OrderByPipe,
        OrderByLocalPipe,
        BitratePipe,
        SafeUrlPipe,
        DesnakePipe,
        ObjectTypeLetterPipe,
        BytesPipe,
        DateTimeZonePipe,
        NamesPipe,
        BracketsPipe,
        VersionPipe,
        StatePipe,
        ErrorMessagePipe,
        UptimePipe,
        FilterPipe,
        TimestampPipe,
        FeederInputPipe,
        FeederInputTypePipe,
        FeederInputSourcePipe,
        FeederInputStatusPipe,
        BroadcasterInputPipe,
        BroadcasterInputPartialPipe,
        BroadcasterInputStatusPipe,
        BroadcasterOutputPipe,
        BroadcasterOutputErrorPipe,
        BroadcasterOutputStatusPipe,
        ReceiverOutputPipe,
        ReceiverOutputTypePipe,
        ReceiverOutputStatusPipe,
        ReceiverOutputTargetPipe,
        TimezonePipe,
        SingularPipe,
        MultiLevelFilter,
        NetworkPipe,
        DeescalatePipe,
        UIdPipe,
        ChromaMapperPipe,
        LocationDisplayNamePipe,
        MapPipe,
        ZecInputPipe,
        ZecInputStatusPipe,
        MinuteSecondsPipe
    ],
    exports: [
        FirstLetterPipe,
        StatusClassPipe,
        StatusTextPipe,
        TargetStatusTextPipe,
        StatusIconPipe,
        OrderByPipe,
        OrderByLocalPipe,
        BitratePipe,
        SafeUrlPipe,
        DesnakePipe,
        ObjectTypeLetterPipe,
        BytesPipe,
        DateTimeZonePipe,
        NamesPipe,
        BracketsPipe,
        VersionPipe,
        StatePipe,
        ErrorMessagePipe,
        UptimePipe,
        FilterPipe,
        TimestampPipe,
        FeederInputPipe,
        FeederInputTypePipe,
        FeederInputSourcePipe,
        FeederInputStatusPipe,
        BroadcasterInputPipe,
        BroadcasterInputPartialPipe,
        BroadcasterInputStatusPipe,
        BroadcasterOutputPipe,
        BroadcasterOutputErrorPipe,
        BroadcasterOutputStatusPipe,
        ReceiverOutputPipe,
        ReceiverOutputTypePipe,
        ReceiverOutputStatusPipe,
        ReceiverOutputTargetPipe,
        TimezonePipe,
        SingularPipe,
        MultiLevelFilter,
        NetworkPipe,
        DeescalatePipe,
        UIdPipe,
        ChromaMapperPipe,
        LocationDisplayNamePipe,
        MapPipe,
        ZecInputPipe,
        ZecInputStatusPipe,
        MinuteSecondsPipe
    ],
    providers: [
        FirstLetterPipe,
        StatusClassPipe,
        StatusTextPipe,
        TargetStatusTextPipe,
        StatusIconPipe,
        OrderByPipe,
        OrderByLocalPipe,
        BitratePipe,
        SafeUrlPipe,
        DesnakePipe,
        ObjectTypeLetterPipe,
        BytesPipe,
        DateTimeZonePipe,
        NamesPipe,
        BracketsPipe,
        VersionPipe,
        StatePipe,
        ErrorMessagePipe,
        UptimePipe,
        FilterPipe,
        TimestampPipe,
        FeederInputPipe,
        FeederInputTypePipe,
        FeederInputSourcePipe,
        FeederInputStatusPipe,
        BroadcasterInputPipe,
        BroadcasterInputPartialPipe,
        BroadcasterInputStatusPipe,
        BroadcasterOutputPipe,
        BroadcasterOutputErrorPipe,
        BroadcasterOutputStatusPipe,
        ReceiverOutputPipe,
        ReceiverOutputTypePipe,
        ReceiverOutputStatusPipe,
        ReceiverOutputTargetPipe,
        TimezonePipe,
        SingularPipe,
        MultiLevelFilter,
        NetworkPipe,
        DeescalatePipe,
        UIdPipe,
        ChromaMapperPipe,
        LocationDisplayNamePipe,
        MapPipe,
        ZecInputPipe,
        ZecInputStatusPipe,
        MinuteSecondsPipe
    ]
})
export class SharedModule {}
